import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import {
    CdkDragDrop,
    copyArrayItem,
    moveItemInArray,
} from '@angular/cdk/drag-drop';
import { HttpErrorResponse } from '@angular/common/http';
import { Subscription } from 'rxjs';

import {
    LocationModelInfo,
    ScreenLocationService,
} from '../../private-campaign/services/screenLocation.service';
import { UserAuthService } from '../../../services/user/user-auth.service';
import { environment } from '../../../../environments/environment';
import { PlayerComponent } from '../../spots/player/player.component';
import { MenuContextService } from '../../layout/services/menu-context.service';
import { CampaignService } from '../../private-campaign/services/campaign.service';
import { AlertService } from '../../../services/alert/alert.service';
import { SignalrService } from '../../../services/signalr/signalr.service';
import {
    WEATHER_PARAMS,
    WEATHER_PARAMS_ICONS,
} from '../../weather/weather.model';

@Component({
    selector: 'app-screen-details',
    templateUrl: './screen-details.component.html',
    styleUrls: ['./screen-details.component.scss'],
})
export class ScreenDetailsComponent implements OnInit {
    @Input() location!: LocationModelInfo;

    private baseUrl: string;
    public faceId: null;
    organizationId: number;
    public weatherParams: string[];

    constructor(
        private screenLocation$: ScreenLocationService,
        private userService: UserAuthService,
        public dialog: MatDialog,
        public menuContext$: MenuContextService,
        private signalr: SignalrService,
        public router: Router,
        public campaignService: CampaignService,
        public alertService: AlertService
    ) {
        this.baseUrl = environment.apiBaseUrl;
        this.weatherParams = WEATHER_PARAMS;
    }

    ngOnInit(): void {
        this.organizationId = UserAuthService.user.organizationId;
    }
    ngOnDestroy(): void {}
    addCampaign(faceId: number) {
        this.router.navigateByUrl('spots/selectmethod?faceId=' + faceId);
    }

    playSpot(spotId: any, fileId: any) {
        const dialogRef = this.dialog.open(PlayerComponent, {});
        
        console.error("No storageId provided");
        
        dialogRef.componentInstance.loadVideo();
    }

    /**
     * @deprecated
     * @param campaignId
     * @param isProtected
     * @param duplicationTemplate
     * @param faceId
     * @param spotId
     */
    // editCampaignSpot(
    // 	campaignId: number,
    // 	isProtected: boolean,
    // 	duplicationTemplate: any,
    // 	faceId: number
    // ) {
    // 	if (isProtected) {
    // 		const dialogRef = this.dialog.open(duplicationTemplate, {
    // 			data: { key: '' },
    // 		});

    // 		dialogRef.afterClosed().subscribe((result) => {
    // 			if (result) {
    // 				this.campaignService
    // 					.duplicateCampaign(faceId, campaignId)
    // 					.subscribe((resutl) => {
    // 						this.router.navigateByUrl(
    // 							'spots/selectmethod?campaignId=' + resutl.id
    // 						);
    // 					});
    // 			}
    // 		});
    // 	} else {
    // 		this.router.navigateByUrl('spots/selectmethod?campaignId=' + campaignId);
    // 	}
    // }

    /**
     * @deprecated
     * @param campaignId
     * @param spotId
     * @param isProtected
     * @param duplicationTemplate
     * @param faceId
     */
    // editCampaignParams(
    // 	campaignId: number,
    // 	isProtected: boolean,
    // 	duplicationTemplate: any,
    // 	faceId: number,
    // 	spotId: number
    // ) {
    // 	if (isProtected) {
    // 		const dialogRef = this.dialog.open(duplicationTemplate, {
    // 			data: { key: '' },
    // 		});

    // 		dialogRef.afterClosed().subscribe((result) => {
    // 			if (result) {
    // 				this.campaignService
    // 					.duplicateCampaign(faceId, campaignId)
    // 					.subscribe((resutl) => {
    // 						this.router.navigateByUrl(
    // 							'private-campaign/' +
    // 								this.organizationId +
    // 								'?campaignId=' +
    // 								resutl.id +
    // 								'&spotId=' +
    // 								spotId
    // 						);
    // 					});
    // 			}
    // 		});
    // 	} else {
    // 		this.router.navigateByUrl(
    // 			'private-campaign/' +
    // 				this.organizationId +
    // 				'?campaignId=' +
    // 				campaignId +
    // 				'&spotId=' +
    // 				spotId
    // 		);
    // 	}
    // }

    /**
     * @deprecated
     * @param campaignId
     * @param spotId
     * @param isProtected
     * @param duplicationTemplate
     * @param faceId
     */
    // editCampaignScreens(
    // 	campaignId: number,
    // 	spotId: number,
    // 	isProtected: boolean,
    // 	duplicationTemplate: any,
    // 	faceId: number
    // ) {
    // 	if (isProtected) {
    // 		const dialogRef = this.dialog.open(duplicationTemplate, {
    // 			data: { key: '' },
    // 		});

    // 		dialogRef.afterClosed().subscribe((result) => {
    // 			if (result) {
    // 				this.campaignService
    // 					.duplicateCampaign(faceId, campaignId)
    // 					.subscribe((resutl) => {
    // 						this.router.navigateByUrl(
    // 							'private-campaign/screens/' +
    // 								resutl.id +
    // 								'?organizationId=' +
    // 								this.organizationId +
    // 								'&editMode=true&fromPark=true&spotId=' +
    // 								spotId +
    // 								'&campaignId=' +
    // 								resutl.id
    // 						);
    // 					});
    // 			}
    // 		});
    // 	} else {
    // 		this.router.navigateByUrl(
    // 			'private-campaign/screens/' +
    // 				campaignId +
    // 				'?organizationId=' +
    // 				this.organizationId +
    // 				'&editMode=true&fromPark=true&spotId=' +
    // 				spotId +
    // 				'&campaignId=' +
    // 				campaignId
    // 		);
    // 	}
    // }

    /**
     * @deprecated
     * @param campaignId
     * @param templateReferenceId
     * @param spotId
     * @param isProtected
     * @param duplicationTemplate
     * @param faceId
     */
    // editCurrentCampaignSpot(
    // 	campaignId: number,
    // 	templateReferenceId: number,
    // 	spotId: number,
    // 	isProtected: boolean,
    // 	duplicationTemplate: any,
    // 	faceId: number
    // ) {
    // 	if (isProtected) {
    // 		const dialogRef = this.dialog.open(duplicationTemplate, {
    // 			data: { key: '' },
    // 		});

    // 		dialogRef.afterClosed().subscribe((result) => {
    // 			if (result) {
    // 				this.campaignService
    // 					.duplicateCampaign(faceId, campaignId)
    // 					.subscribe((resutl) => {
    // 						const myQueryParams = [{ id: templateReferenceId, edit: true }];
    // 						if (campaignId) {
    // 							this.router.navigateByUrl(
    // 								'spots/generator?option=' +
    // 									JSON.stringify(myQueryParams) +
    // 									'&organizationId=' +
    // 									this.organizationId +
    // 									'&campaignId=' +
    // 									resutl.id +
    // 									'&spotId=' +
    // 									spotId
    // 							);
    // 						}
    // 					});
    // 			}
    // 		});
    // 	} else {
    // 		const myQueryParams = [{ id: templateReferenceId, edit: true }];
    // 		if (campaignId) {
    // 			this.router.navigateByUrl(
    // 				'spots/generator?option=' +
    // 					JSON.stringify(myQueryParams) +
    // 					'&organizationId=' +
    // 					this.organizationId +
    // 					'&campaignId=' +
    // 					campaignId +
    // 					'&spotId=' +
    // 					spotId
    // 			);
    // 		}
    // 		// this.router.navigateByUrl('spots/generator?organizationId=' + this.organizationId + '&campaignId=' + campaignId);
    // 	}
    // }

    public dialogDeleteCampaign(
        template: any,
        isProtected: boolean,
        duplicationTemplate: any,
        faceId: number,
        campaignId: number
    ): void {
        if (isProtected) {
            const dialogRef = this.dialog.open(duplicationTemplate, {
                data: { key: '' },
            });

            dialogRef.afterClosed().subscribe((result) => {
                if (result) {
                    //TO DO DISABLE CAMPAIGN result.id;
                    // this.campaignService.duplicateCampaign(faceId, campaignId).subscribe((resutl)=>{
                    // 	//
                    // })
                }
            });
        } else {
            this.dialog.open(template, {
                width: '500',
            });
        }
    }

    public removeCampaign(campaignId: number): void {
        this.campaignService.delete(campaignId).subscribe((d) => {
            this.alertService.show({
                message: 'Cette campagne a bien été supprimée',
                duration: 5000,
            });
            this.ngOnInit();
        });
    }

    public removeFaceFromCampaign(campaignId: number, faceId: number): void {
        this.screenLocation$
            .removeFaceFromCampaign(campaignId, faceId)
            .subscribe((d) => {
                this.alertService.show({
                    message: 'Cette campagne a bien été supprimée de cet écran',
                    duration: 5000,
                });
                this.ngOnInit();
            });
    }

    seeFutureDiff(face: any) {
        face.seeFutureDiff = true;
    }

    hideFutureDiff(face: any) {
        face.seeFutureDiff = false;
    }

    openDetail(faceId: any) {
        const dialogRef = this.dialog.open(ScreenDetailsComponent, {
            data: { key: '' },
        });
    }
    public drop(event: CdkDragDrop<any[]>, face: any): void {
        if (this.userService.isAllowed('CreateSpot', 'CanCreateSpot')) {
            if (event.previousContainer === event.container) {
                moveItemInArray(
                    event.container.data,
                    event.previousIndex,
                    event.currentIndex
                );
            } else {
                copyArrayItem(
                    event.previousContainer.data,
                    event.container.data,
                    event.previousIndex,
                    event.currentIndex
                );
            }
            // Put in an array all ids from the actual diffs of the face in which a spot has been moved
            const newOrder = face.actualDiffs.map((s) => s.diffId);
            this.screenLocation$.setPlaylistOrder(face.id, newOrder).subscribe({
                next: (d: any) => {
                    this.alertService.show({
                        message: 'Nouvel ordre de playlist enregistré',
                        duration: 5000,
                    });
                },
                error: (err: HttpErrorResponse) => {
                    this.alertService.show({
                        message: `Le nouvel ordre n'a pas pu être enregistré. Erreur: ${err.status}`,
                        duration: 5000,
                    });
                },
            });
        } else {
            this.alertService.show({
                message: `Vous ne pouvez pas modifier l'ordre de la playlist`,
                duration: 2500,
            });
        }
    }

    reportProblem(faceId) {
        this.router.navigateByUrl('tickets/create?faceId=' + faceId);
        // this.router.navigateByUrl('tickets/create');
    }

    addNew() {
        this.router.navigateByUrl('spots/selectmethod?faceId=' + 13744);
    }
}
